const scrollAnimations = () => {

    /**
     * Setup
     */

    const isMobile = window.innerWidth < 768;
    const blocks = [];

    /**
     * Logo
     */
    // const navbar = document.querySelector('.navbar__section');
    // if (navbar) {
    //     const logo = navbar.querySelector('.navbar__logo');
    //     setupElement(navbar, logo, 'fade-down', navbar, 0.1);
    // }

    /**
     * Block Video
     */
    const blockVideo = document.querySelectorAll('.block-video');
    if (blockVideo) {
        for (const block of blockVideo) {
            const video = block.querySelector('.wp-block-video');
            const title = block.querySelector('.titolo_pb');
            setupElement(block, video, 'fade-in', block, 0.4);
            setupElement(block, title, 'fade-in', block, 0.8);
        }
    }

    /**
     * Block Text
     */
    const blockText = document.querySelectorAll('.block-text');
    if (blockText) {
        for (const block of blockText) {
            const colsLeft = block.querySelectorAll('.wp-block-publifarm-column:nth-child(odd)');
            const colsRight = block.querySelectorAll('.wp-block-publifarm-column:nth-child(even)');
            colsLeft.forEach(colLeft => {
                setupElement(block, colLeft, 'fade-in', colLeft);
            })
            colsRight.forEach(colRight => {
                setupElement(block, colRight, 'fade-in', colRight);
            })
        }
    }

    /**
     * Block Alternate Images
     */
    const blockAlternateImages = document.querySelectorAll('.block-alternate-images');
    if (blockAlternateImages) {
        for (const block of blockAlternateImages) {
            const colTop = block.querySelector('.wp-block-publifarm-column:first-child');
            const colLeft1 = block.querySelector('.wp-block-publifarm-column:nth-child(2)');
            const colRight1 = block.querySelector('.wp-block-publifarm-column:nth-child(3)');
            const colLeft2 = block.querySelector('.wp-block-publifarm-column:nth-child(4)');
            const colRight2 = block.querySelector('.wp-block-publifarm-column:nth-child(5)');

            setupElement(block, colTop, 'fade-right', colTop);
            setupElement(block, colLeft1, 'fade-right', colLeft1, 0.4);
            setupElement(block, colRight1, 'fade-left', colRight1, 0.4);
            setupElement(block, colLeft2, 'fade-right', colLeft2, 0.8);
            setupElement(block, colRight2, 'fade-left', colRight2, 0.8);
        }
    }

    /**
     * Block Boxes
     */
    const blockBoxes = document.querySelectorAll('.block-boxes');
    if (blockBoxes) {
        for (const block of blockBoxes) {
            const title = block.querySelector('.titolo_pb')
            const slider = block.querySelector('.swiper')
            const btn = block.querySelector('.wp-block-button')
            setupElement(block, title, 'fade-in', block, 0.2);
            setupElement(block, slider, 'fade-in', block, 0.4);
            setupElement(block, btn, 'fade-in', block, 0.6);


        }
    }

    /**
     * Block List
     */
    const blockAccordion = document.querySelectorAll('.block-list');
    if (blockAccordion) {
        for (const block of blockAccordion) {
            const colTitolo = block.querySelector('.wp-block-publifarm-column:has(.titolo_pb.h6)');
            const colText = block.querySelector('.wp-block-publifarm-column:has(.titolo_pb.h2)');
            const colImage = block.querySelector('.wp-block-publifarm-column:has(.wp-block-image)');
            const colAccordion = block.querySelector('.wp-block-publifarm-column:has(.block-accordion)');
            setupElement(block, colTitolo, 'fade-right', colTitolo, 0.2);
            setupElement(block, colText, 'fade-left', colText, 0.4);
            setupElement(block, colImage, 'fade-right', colImage, 0.8);
            setupElement(block, colAccordion, 'fade-left', colAccordion, 0.8);
        }
    }

    /**
     * Block Numbers
     */
    const blockNumbers = document.querySelectorAll('.block-numbers');
    if (blockNumbers) {
        for (const block of blockNumbers) {
            const b = block.querySelector('.block-numbers__section')
            setupElement(block, b, 'fade-in', b);

        }
    }

    /**
     * Block Products - non va con sticky
     */
    // const blockProducts = document.querySelectorAll('.block-products__section');
    // if (blockProducts) {
    //     for (const block of blockProducts) {
    //         const labelList = block.querySelector('.block-products__label__list')
    //         const gallery = block.querySelectorAll('.block-products__gallery__list:first-child .block-products__gallery__item')
    //         setupElement(block, labelList, 'fade-right', labelList);
    //         gallery.forEach(item => {
    //             setupElement(block, item, 'fade-left', item);
    //         })
    //     }
    // }

    /**
     * Footer
     */

    const certificazioni = document.querySelector('.certificazioni__section');
    if (certificazioni) {
        const title = certificazioni.querySelector('.h6')
        const slider = certificazioni.querySelector('.swiper')
        setupElement(certificazioni, title, 'fade-in', certificazioni, 0.2);
        setupElement(certificazioni, slider, 'fade-in', certificazioni, 0.4);
    }

    const footer = document.querySelector('#footer');
    if (footer) {
        const contentInfo = footer.querySelector('.col-12:has(.footer__logo)');
        const contentForm = footer.querySelector('.col-12:has(.wpcf7)');

        setupElement(footer, contentInfo, 'fade-right', contentInfo);
        setupElement(footer, contentForm, 'fade-left', contentForm);
    }

    /**
     * Init Blocks elements to animate and set up its parent
     */
    for (const block of blocks) {
        block.parent.style.overflow = 'hidden';

        genAnimations(block.animations);
    }

    /**
     * Setup elements to animate
     * @param {HTMLElement} parent - The parent element
     * @param {HTMLElement} element - The element to animate
     * @param {string} type - The animation type
     * @param {HTMLElement} trigger - The trigger element
     * @param {number | null} delay - The animation delay
     * @param {boolean} stagger - The animation stagger
     */


    function setupElement(
        parent,
        element,
        type,
        trigger,
        delay = null,
        stagger = false
    ) {
        const animation = {
            element,
            type,
            trigger: trigger,
            delay,
            stagger,
        };

        // push element if not already in array, else just push the animation in the animations array
        if (blocks.some(block => block.parent === parent)) {
            blocks
                .find(block => block.parent === parent)
                .animations.push(animation);
            return;
        }

        blocks.push({ parent, animations: [animation] });
    }

    /**
     * Core Animation function
     * @param {Array} animations - Array of objects containing the GSAP properties for the animations
     */
    function genAnimations(animations) {
        animations.forEach(item => {
            // Default options
            const animationOptions = {
                scrollTrigger: {
                    trigger: item.trigger,
                    start: 'top 80%',
                },
                duration: item.speed ?? 0.5,
                delay: item.delay ?? 0,
                stagger: item.stagger && !isMobile ? 0.3 : false,
                opacity: 0,
            };

            // Animation types
            switch (item.type) {
                case 'fade-in':
                    animationOptions.scale = 0.75;
                    break;
                case 'fade-in-half':
                    animationOptions.scale = 0.9;
                    break;
                case 'fade-left':
                    animationOptions.x = 50;
                    break;
                case 'fade-right':
                    animationOptions.x = -50;
                    break;

                case 'fade-up':
                    animationOptions.y = 50;
                    break;

                case 'fade-down':
                    animationOptions.y = -50;
                    break;
                default:
                    console.error(
                        'Wrong or missing data-animation type:',
                        item.type
                    );
            }

            if (item.element) {
                gsap.from(item.element, {
                    ...animationOptions,
                });
            }
        });
    }

    /******************************************************
     Animated Counters
     ******************************************************/

    const animatedCounters = document.querySelectorAll('.animated-counter');

    for (const counter of animatedCounters) {
        gsap.from(counter, {
            scrollTrigger: {
                trigger: counter,
                start: 'top bottom',
            },
            textContent: '0',
            duration: 1,
            ease: 'power1.inOut',
            modifiers: {
                // italian punctuation and no decimals
                textContent: value =>
                    value.toLocaleString('it-IT', {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                    }),
            },
        });
    }
}


export default scrollAnimations;